import '@urbanx/agx-ui-components/dist/index.css';
import '@urbanx/agx.ui-components2/dist/agx.ui-components2.css';
import './App.scss';

import { RouterProvider } from 'react-router-dom';
import router from './constants/router';
import { useEffect, useState } from 'react';
import { AgencyContext } from './contexts';
import LogRocket from 'logrocket';
import {
  AgxDialogProvider,
  AgxToasts,
  applyTheme,
  staffPortalLightTheme,
} from '@urbanx/agx.ui-components2';
import { AgxAuth } from '@urbanx/agx.auth.client';
import AppConfig from 'config/AppConfig';
import ApiProviders from 'api/ApiProviders';
import { AgencyModel } from '@urbanx/agx.agencies.client';
import SignalrComms from 'api/SignalrComms';

const App = () => {
  useEffect(() => {
    LogRocket.init('dzljjh/autopilot');

    applyTheme(staffPortalLightTheme, 'staff-portal', true, document.documentElement, 'light');
  }, []);

  const agency = useState<AgencyModel | undefined>(undefined);

  return (
    <AgxToasts>
      <AgxAuth apiConfig={AppConfig}>
        <ApiProviders>
          <AgencyContext.Provider value={agency}>
            <SignalrComms>
              <AgxDialogProvider>
                <RouterProvider router={router} />
              </AgxDialogProvider>
            </SignalrComms>
          </AgencyContext.Provider>
        </ApiProviders>
      </AgxAuth>
    </AgxToasts>
  );
};

export default App;
